import { useEffect, type MouseEvent, type ReactElement, type ReactNode } from 'react';

interface ModalShellProps {
  title: string;
  subtitle: string;
  onClose: () => void;
  /** Wider dialog for tables and charts. */
  wide?: boolean;
  children: ReactNode;
}

export function ModalShell({ title, subtitle, onClose, wide, children }: ModalShellProps): ReactElement {
  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent): void => {
      if (event.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [onClose]);

  const onBackdropMouseDown = (event: MouseEvent<HTMLDivElement>): void => {
    if (event.target === event.currentTarget) onClose();
  };

  return (
    <div className="fsg-modal-backdrop" onMouseDown={onBackdropMouseDown}>
      <div className={wide ? 'fsg-modal fsg-modal--wide' : 'fsg-modal'} role="dialog" aria-modal="true" aria-label={title}>
        <header className="fsg-modal-head">
          <div>
            <h2 className="fsg-modal-title">{title}</h2>
            <p className="fsg-modal-sub">{subtitle}</p>
          </div>
          <button type="button" className="fsg-icon-btn" onClick={onClose} aria-label="Close">
            ×
          </button>
        </header>
        {children}
      </div>
    </div>
  );
}
